import './DeparturesReportUpdate.scss';

import { useDeparturesReportUpdateForm } from "../../../hooks/useDeparturesReportUpdateForm";
import { useGetUpdateFieldOptions } from "../../../hooks/useGetUpdateFieldOptions";

import { Field } from "../../../common-components/Field/Field";

const DeparturesReportUpdate = ({id}) => {
    const { formId, adaptedFieldList } = useDeparturesReportUpdateForm({id});

    useGetUpdateFieldOptions();

    return (
        <div className={"departures-report-update"}>
            <div className={"departures-report-update_container"}>
                <div className={"departures-report-update_form"}>
                    {adaptedFieldList.map((category) => (
                        <div className={"departures-report-update_form-category"}>
                            <div className={"departures-report-update_form-category_title"}>
                                {category.category}
                                <div className={"departures-report-update_form-category_attention"}>
                                    {category.categoryAttention}
                                </div>
                            </div>
                            <div className={"departures-report-update_form-category_items"}>
                                {category.fields.map((field) => (
                                    <Field
                                        key={field.key}
                                        formId={formId}
                                        label={field.label}
                                        name={field.name}
                                        options={field.options}
                                        propertyLabel={field.label}
                                        type={field.type}
                                        validationRules={field.validationRules}
                                        fieldStructure={field.fieldStructure}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default DeparturesReportUpdate;